import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAllPosts } from '../hooks';
import { AdminPostList } from '../components';
import { seedPosts } from '../seedData';
import './AdminPage.css';

export function AdminPage() {
  const { posts, loading, error } = useAllPosts();
  const [seeding, setSeeding] = useState(false);
  const [seedError, setSeedError] = useState('');
  const [seedSuccess, setSeedSuccess] = useState(false);

  const handleSeed = async () => {
    setSeeding(true);
    setSeedError('');
    setSeedSuccess(false);

    try {
      await seedPosts();
      setSeedSuccess(true);
    } catch (err) {
      console.error('Seed error:', err);
      setSeedError(err.message || 'Failed to add posts');
    } finally {
      setSeeding(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <h1>Admin</h1>
      </div>

      <div className="admin-page__actions">
        <Link to="/admin/new" className="btn btn-primary">
          New Post
        </Link>
        <button
          onClick={handleSeed}
          disabled={seeding || loading}
          className="btn btn-secondary"
        >
          {seeding ? 'Adding...' : 'Add Sample Posts'}
        </button>
      </div>

      {seedError && (
        <div style={{ color: 'red', marginBottom: '16px', fontFamily: 'var(--font-sans)', fontSize: '0.9rem' }}>
          Error: {seedError}
        </div>
      )}

      {seedSuccess && (
        <div style={{ color: 'green', marginBottom: '16px', fontFamily: 'var(--font-sans)', fontSize: '0.9rem' }}>
          Posts added successfully! Refresh to see them.
        </div>
      )}

      <AdminPostList posts={posts} loading={loading} error={error} />
    </div>
  );
}
